var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-screen',{staticClass:"screen-rules",attrs:{"title":_vm.texts.ob.rules.title,"menu":true,"textOnly":true}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }